module.exports = __webpack_public_path__ + "static/media/banner_pw.665dafc1.jpg";